var Marionette = require('marionette'),
    DocIndexesLayout = require('./view/layout/layout'),
    SubApp = require('../common/SubApp');

//todo: when add subapp -- add the channel (gl)
module.exports = SubApp.extend({
    initialize: function(options) {

        this.vChannel = options.vChannel;

        this.layout = new DocIndexesLayout({
            el: options.$container,
            collection: options.indexes
        }).render();

    },
    onBeforeDestroy: function() {
        return this.layout.destroy();
    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/index/indexes.js
 ** module id = 572
 ** module chunks = 0
 **/